<!-- MitPeopleSearch.vue -->
<template>
    <v-text-field
      v-model="searchTerm"
      label="General Search"
      prepend-icon="mdi-magnify"
      clearable
      @input="onSearchInput"
      @focus="clearFilters"
    ></v-text-field>
</template>
  
<script>
  export default {
    name: 'MitPeopleSearch',
    data() {
      return {
        searchTerm: '',
      };
    },
    methods: {
      onSearchInput() {
        this.$emit('search-input', this.searchTerm);
      },
      clearFilters() {
        this.$emit('clear-filters');
      },
    },
  };
</script>
  
<style scoped>
</style>
  